import React, { useState } from 'react';
import './services.css';

const services = [
    {
        title: 'Backend Systems',
        icon: 'bx bx-server services__icon',
        modalTitle: 'Backend and API Systems',
        description: 'Building maintainable backend systems with FastAPI, ASP.NET Core, REST APIs, layered architecture, validation, and consistent error handling.',
        items: ['API, service, and repository layers', 'Authentication and input validation', 'SQL-backed business workflows']
    },
    {
        title: 'RAG & Search',
        icon: 'bx bx-search-alt services__icon',
        modalTitle: 'RAG and Knowledge Retrieval',
        description: 'Developing retrieval systems with PostgreSQL, pgvector, query normalization, synonym expansion, reranking, and relevance thresholds.',
        items: ['Vector search and semantic retrieval', 'Knowledge-base ingestion', 'Routing and citizen-service workflows']
    },
    {
        title: 'AI & Voice Agents',
        icon: 'bx bx-bot services__icon',
        modalTitle: 'AI Assistants and Voice Agents',
        description: 'Designing conversational voice-agent flows for support, verification, service intake, complaint handling, and structured outcome logging.',
        items: ['Prompt engineering and function calling', 'DTMF and SMS OTP flows', 'Ticketing and service-intake automation']
    },
    {
        title: 'Workflow Automation',
        icon: 'bx bx-flow-chart services__icon',
        modalTitle: 'Workflow Automation and Integrations',
        description: 'Orchestrating n8n and Activepieces workflows for API integrations, complaint records, knowledge ingestion, transcripts, and daily reports.',
        items: ['n8n and Activepieces orchestration', 'Webhook and API integrations', 'Transcript and report automation']
    }
];

const CvServices = () => {
    const [toggleState, setToggleState] = useState(-1);

    return (
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What I build</span>

            <div className="services__container container grid">
                {services.map((service, index) => (
                    <div className="services__content" key={service.title}>
                        <div>
                            <i className={service.icon}></i>
                            <h3 className="services__title">{service.title}</h3>
                        </div>

                        <span className="services__button" onClick={() => setToggleState(index)}>View More
                        <i className="uil uil-arrow-right services__button-icon"></i></span>

                        <div className={toggleState === index ? "services__modal active-modal" : "services__modal"}>
                            <div className="services__modal-content">
                                <i className="uil uil-times services__modal-close" onClick={() => setToggleState(-1)}></i>
                                <h3 className="services__modal-title">{service.modalTitle}</h3>
                                <p className="services__modal-description">
                                    {service.description}
                                </p>

                                <ul className="services__modal-services grid">
                                    {service.items.map((item) => (
                                        <li className="services__modal-service" key={item}>
                                            <i className="uil uil-check-circle services__modal-icon"></i>
                                            <p className="services__modal-info">{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CvServices;
